<template>
    <div>
        <a-modal title="引入历史开票信息" v-model="visible" width="50%" @cancel="close" destroyOnClose>
            <a-form-model class="common-form-inline" :rules="ruleForm" ref="ruleForm" :model="pageData"
                :label-col="{ span: 8 }" :wrapper-col="{ span: 13 }"
                style="display: flex;align-items: center;justify-content: space-around;">
                <a-form-model-item style="width:320px" label="接收方" prop="rcPtyName">
                    <select-search style="width: 210px;" v-model="pageData.tenantObj" :searchSource="true"
                        :dataSource="importOption" :other="true" headNameFirst="接收方名称" headNameSecond="社会信用代码"
                        valuePorp="cstId" labelPorp="cstNm" @handleChange="changeTenant"
                        @handleSearch="handleSearchImport"></select-search>
                </a-form-model-item>
                <a-form-model-item style="width:320px" label="祺信编号" prop="gldId">
                    <a-input v-model="pageData.gldId" />
                    <!-- <select-search style="width: 210px;" v-model="pageData.tenantObj" :searchSource="true"
                        :dataSource="importOption" :other="true" headNameFirst="接收方名称" headNameSecond="社会信用代码"
                        valuePorp="cstOrgCode" labelPorp="cstNm" @handleChange="changeTenant"
                        @handleSearch="handleSearchImport"></select-search> -->
                </a-form-model-item>
                <a-form-model-item label="" prop="">
                    <a-button @click="search" class="search-btn-item" type="primary">查询</a-button>
                </a-form-model-item>
            </a-form-model>
            <div class="common-table-box">
                <a-table :row-selection="rowSelection" :columns="columns" :dataSource="tableData"
                    :rowKey="record => record.id" :bordered="true" :loading="loading" :pagination="pagination"
                    @change="handleTableChange">
                    <template slot="hdlDt" slot-scope="text,record">
                        <div>
                            {{ record.hdlDt | formatDate }}
                        </div>
                    </template>
                </a-table>
                <div :class="{ 'table-total': pagination.total > 0, 'table-total-none': pagination.total == 0 }">
                    共有记录：
                    <span class="text-color-blue">{{ pagination.total }} 条</span>
                </div>
            </div>
            <template slot="footer">
                <a-button class="btn-blue-line" @click="close()">关闭</a-button>
                <a-button type="primary" :loading="loading" @click="handleOk">确定</a-button>
            </template>
        </a-modal>
    </div>
</template>

<script>
import { selectSellerCst } from "@/api/rcvbBuy.js";
import { circleQuery } from "@/api/circle.js";
import { queryGoldPageApi, findGoldEstbOrRcPtyOrPypt } from "@/api/gold.js"
import { mapState, mapGetters, mapActions, mapMutations } from "vuex"
export default {
    data() {
        return {
            selectedRowKeys: [],
            importOption: [],
            pageData: {
                tenantObj: {},
            },
            visible: false,
            loading: false,
            columns: [
                {
                    title: '祺信编号',
                    dataIndex: 'gldId',
                },
                {
                    title: '接收方',
                    dataIndex: 'rcPtyNm',
                },
                {
                    title: '开立日期',
                    dataIndex: 'hdlDt',
                    scopedSlots: { customRender: "hdlDt" }
                },
                {
                    title: '开立金额',
                    dataIndex: 'gldAmt',

                },
                // {
                //     title: '相关附件',
                //     dataIndex: '',
                // },
            ],
            tableData: [],
            ruleForm: {

            },
            pagination: {
                pageSize: 3,
                current: 1,
                sortField: "",
                sortOrder: "",
                total: 0,
                showSizeChanger: true,
                showQuickJumper: true,
                pageSizeOptions: ['5', '10', '20', '50', '100'],
                showTotal: (total) => {
                    return `共 ${total} 条`
                }
            },
            type: null,
        }
    },
    computed: {
        ...mapGetters({
            userObj: "home/getUserObj",
        }),
        rowSelection() {
            return {
                type: 'radio',
                selectedRowKeys: this.selectedRowKeys,
                onChange: (selectedRowKeys) => {
                    this.selectedRowKeys = selectedRowKeys
                }
            }
        }
    },
    methods: {
        open(val) {
            this.visible = true;
            this.type = val
            this.getTableData()
        },
        close() {
            this.visible = false;
        },
        toShow() {
            if (this.selectedRows.length > 0) {
                const selectedRow = this.selectedRows[0];
                // 在这里处理选中的行数据，例如回显到页面
                console.log('Selected Row:', selectedRow);
                // 假设有一个方法来处理回显逻辑
                this.handleShowSelectedRow(selectedRow);
            } else {
                this.$message.warning('请选择一行数据');
            }
        },
        handleOk() {
            this.loading = true;
            // 确保至少选中了一行
            if (this.selectedRowKeys.length === 0) {
                this.$message.warning('请选择一行数据');
                this.loading = false;
                return;
            }
            // 获取选中的行数据
            const selectedRow = this.tableData.find(row => row.id === this.selectedRowKeys[0]);
            if (selectedRow) {
                this.handleShowSelectedRow(selectedRow)
                this.$emit('select-history', selectedRow);
                // 关闭弹窗
                this.close();
            } else {
                this.$message.error('未找到选中的行数据');
            }
            this.loading = false;
        },
        handleShowSelectedRow(selectedRow) {
            // 将选中的行数据赋值到当前页面的字段
            this.pageData.rcPtyNm = selectedRow.rcPtyNm; // 接收方名称
            this.pageData.rcPtyOrgCode = selectedRow.rcPtyOrgCode;     // 社会信用代码
            this.pageData.gldAmt = selectedRow.gldAmt;   // 开立金额
            this.pageData.exDay = selectedRow.exDay;   // 兑付日期
            this.pageData.canBeModified = selectedRow.canBeModified;   // 是否可变更
            this.pageData.odueRate = selectedRow.odueRate;   // 罚息利率
            this.pageData.fileList = selectedRow.fileList;   // 附件列表
        },
        search() {
            this.getTableData()
        },
        totalPayable(list, key) {
            return list.reduce((acc, rec) => {
                return acc + (+rec[key] || 0);
            }, 0);
        },
        handleSearch(value, data) {
            selectSellerCst({
                pageSize: 10,
                effStCd: 1,
                statusCode: 0,
                state: 2,
                userName: value || "",
                pageNum: 1,
                pageType: "GldQuery",
            })
                .then(res => {
                    this.importOption = res.data.grid.list;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        changeTenant(data, node) {
            console.log("%c Line:191 🥪 data", "color:#f5ce50", data);
            console.log("%c Line:191 🍌 node", "color:#6ec1c2", node);
            this.pageData.tenantNode = node;
            if (this.otherOpen == true) {
                this.pageData.rcPtyName = node.cstNm
                this.pageData.cstOrgCode = node.cstOrgCode
                this.pageData.rcPty = node.guaranteeCstId
            }
            if (!node) {
                this.pageData.tenantObj = {};

            }
        },
        handleSearchImport(value, data) {
            const cstIds = this.userObj.cstIds.join(",");
            findGoldEstbOrRcPtyOrPypt({
                cstNm: value,
                tab: 2,
                pageSize: 10,
                pageNum: 1,
                queryType: 0,
                cstIds: cstIds,
                estb: cstIds,
                pypt: cstIds,
            })
                .then(res => {
                    this.importOption = res.data.grid.list;
                })
                .catch(error => {
                    console.log(error);
                });
        },
        getTableData() {
            let params = {};
            const cstIds = this.userObj.cstIds.join(",");

            console.log("%c Line:215 🌶", "color:#2eafb0", this.pageData.tenantObj);
            params = {
                pageNum: this.pagination.current,
                pageSize: this.pagination.pageSize,
                openType: this.type == 0 ? 0 : 1,
                gldStCds: "1,6",
                pageType: "GldQuery",
                openHistory: this.type == 0 ? true : false,
                gldId: this.pageData.gldId,
                rcPty: this.pageData.tenantObj.key,
                estb: cstIds,
                pypt: cstIds,
            }
            this.loading = true;
            queryGoldPageApi(params)
                .then((res) => {
                    this.pagination.total = res.data.grid.total;
                    this.tableData = res.data.grid.list;
                    this.loading = false;
                })
                .catch((err) => {
                    console.log(err);
                    this.loading = false;
                });
        },

        handleTableChange(pagination, filters, sorter) { //表格排序回调
            this.pagination.current = pagination.current
            this.pagination.pageSize = pagination.pageSize
            this.pagination.total = this.pagination.total || 0
            this.getTableData();
        },
    },
    mounted() {

    },
    created() {

    },
    filters: {
        formatDate(value) {
            if (!value) return ''
            return value.split(' ')[0]
        }
    }
}
</script>

<style scoped></style>



// WEBPACK FOOTER //
// src/pages/bill-manage/payable/historyInfo.vue